import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq({ faq = {} }) {
  const items = faq.items || [];
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-stone-900/40 py-14 md:py-20 border-t border-stone-800"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-10 text-center">
          <span className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold">
            {faq.label || "Dúvidas Frequentes"}
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-50 mt-4">
            {faq.title || "Perguntas & Respostas"}
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {items.map((item, i) => (
              <AccordionItem
                key={item.id || i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-stone-800"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-xl md:text-2xl text-stone-100 hover:text-amber-500 hover:no-underline py-6"
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-stone-400 text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
